import React from 'react';

// Component
import Booking from '../../components/Booking';

export default function Book() {
  return (
    <div className="pt-lxx f f-cs f-1">
      <div className="f-1 w-max-container">
        <Booking />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/routes/book/Book.js